import {
  type CallSubStatusDetail,
  CallSubStatusDetailSchema,
  type CallSubStatusListQuery,
  type CallSubStatusListResponse,
  CallSubStatusListResponseSchema,
  type CreateCallSubStatusRequest,
  type UpdateCallSubStatusRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Call Sub Status master API. Every response is validated with the
 * shared Zod schema so a server change can't sneak past the UI
 * types. Mirrors `query-sub-statuses.api.ts` exactly.
 */

export const listCallSubStatuses = async (
  query: CallSubStatusListQuery,
): Promise<CallSubStatusListResponse> => {
  const { data } = await apiClient.get<unknown>('/call-sub-statuses', { params: query });
  return CallSubStatusListResponseSchema.parse(data);
};

export const getCallSubStatus = async (id: string): Promise<CallSubStatusDetail> => {
  const { data } = await apiClient.get<unknown>(`/call-sub-statuses/${id}`);
  return CallSubStatusDetailSchema.parse(data);
};

export const createCallSubStatus = async (
  payload: CreateCallSubStatusRequest,
): Promise<CallSubStatusDetail> => {
  const { data } = await apiClient.post<unknown>('/call-sub-statuses', payload);
  return CallSubStatusDetailSchema.parse(data);
};

export const updateCallSubStatus = async (
  id: string,
  payload: UpdateCallSubStatusRequest,
): Promise<CallSubStatusDetail> => {
  const { data } = await apiClient.patch<unknown>(`/call-sub-statuses/${id}`, payload);
  return CallSubStatusDetailSchema.parse(data);
};

export const deleteCallSubStatus = async (id: string): Promise<void> => {
  await apiClient.delete(`/call-sub-statuses/${id}`);
};

export const bulkDeleteCallSubStatuses = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/call-sub-statuses/bulk-delete', { ids });
  return data;
};

export const bulkSetCallSubStatusesStatus = async (
  ids: string[],
  isActive: boolean,
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>('/call-sub-statuses/bulk-set-status', { ids, isActive });
  return data;
};
